var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import omit from 'lodash/omit';
import * as React from 'react';
import Icon from '../icon';
import Loader from '../loader';
import { Styled, StyledSearch } from './style';
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyDown = function (e, data) {
            var key = e.key;
            if (key === 'Enter') {
                _this.props.onChange(e, { value: _this.props.value });
            }
        };
        return _this;
    }
    Search.prototype.render = function () {
        var props = omit(this.props, ['right', 'onChange', 'onClear']);
        var _a = this.props, className = _a.className, onClear = _a.onClear, onChange = _a.onChange, loading = _a.loading, value = _a.value;
        return (React.createElement(Styled, { className: className },
            React.createElement(StyledSearch, __assign({ icon: React.createElement(Icon, { name: "search" }) }, props, { onSearchChange: onChange, onKeyPress: this.handleKeyDown })),
            loading && React.createElement(Loader, { inline: true, active: true, size: "mini" }),
            value.length > 0 && React.createElement(Icon, { className: "search-clear", onClick: onClear, name: "close" })));
    };
    Search.defaultProps = {
        right: false,
    };
    return Search;
}(React.Component));
export default Search;
//# sourceMappingURL=index.js.map